import React from 'react';
import { FILTER_CONFIG_NAMES } from './DataConstants';
import { getIsActiveFilterField } from './FilterUtils';
import TagDisplay from '../components/TagDisplay';
import OWAsyncSelect from '../components/ow_async_select/OWAsyncSelect';
import { Select } from 'antd';

export const getPartsFilterConfig = ({ filters, updateFilters, targetCollectionName }) => {
	const vendorFilter = filters[FILTER_CONFIG_NAMES.DEFAULT_VENDORS]
		? {
				...filters[FILTER_CONFIG_NAMES.DEFAULT_VENDORS],
				handleChange: undefined,
		  }
		: null;

	const tagsFilter = filters[FILTER_CONFIG_NAMES.TAGS]
		? {
				...filters[FILTER_CONFIG_NAMES.TAGS],
				handleChange: undefined,
				labelAccessor: (tag) => <TagDisplay tag={tag} />,
				renderItem: (tag) => (
					<Select.Option key={tag.id} value={tag.id}>
						<TagDisplay tag={tag} />
					</Select.Option>
				),
				renderSelectedText: (tag) => tag.label,
				component: OWAsyncSelect,
		  }
		: null;

	return [
		getIsActiveFilterField(updateFilters, targetCollectionName, true),
		vendorFilter,
		tagsFilter,
	].filter(Boolean);
};
